// QR Kiosk v2 — KV2-1 shared contract + small dashboard utils (types + pure
// functions + one press-feedback hook; NO fetch, NO component).
//
// Contract source: ToDo/MachineConnectivity/B4_KIOSK_LIVE_STATUS_PLAN.md §8
// (2026-07-23). B4-T4 (a post-B4-deploy wiring task) adds
// useKioskLiveStatus(internalNumber) beside this type; KV2-1 ships the TYPE +
// renderer only. Do NOT add a fetch in KV2-1.
// (KV2-4: usePressed relocated to ../shared/usePressed — this module no longer
// needs React.)
import { Machine } from "../../models/machinesModels";

export interface KioskLiveStatus {
  available: boolean;
  status?: "Running" | "Idle" | "Down" | "Unknown";
  alarm?: { code: string; message?: string | null; since: string } | null; // since = UTC ISO-8601
  asOf?: string | null; // UTC ISO-8601
}

/**
 * Local re-implementation of v1
 * public/components/kiosk/MachineContextHeader.getPublicMachineImageUrl.
 * Copied (NOT imported) so that MUI-based v1 file never enters the v2 module
 * graph. Keep in sync for parity audits.
 */
export function getKioskMachineImageUrl(machine?: Machine | null): string | null {
  if (!machine) return null;
  // image.content is either a base64 data-URI or an absolute URL served by the API.
  if (machine.image && machine.image.content) return machine.image.content;
  // Fallback to the catalog image URL resolved by the backend.
  if (machine.catalogImageUrl) return machine.catalogImageUrl;
  return null;
}

/** UUID v4 regex for SEC-REQ-5 validation (copied verbatim from v1 KioskMidasChat.tsx). */
export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** SEC-REQ-5 — a MIDAS thread may only ever be opened for a real machine GUID. */
export function isValidMachineUuid(id: string): boolean {
  return !!id && UUID_REGEX.test(id);
}

/** v1 getHealthColor thresholds, tokenized: 0 = green · 1–2 = amber · >2 = red. */
export const getOpenReportsTone = (count: number): "--green" | "--amber" | "--red" =>
  count === 0 ? "--green" : count <= 2 ? "--amber" : "--red";
